var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cartIconWrapper"},[_c('nuxt-link',{attrs:{"to":"/cart"}},[_c('HeaderIcon',{staticClass:"cartIcon",attrs:{"count":_vm.count}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }